<div fxLayout="column" fxLayoutAlign="center center" fxFlexFill>

  <!-- <app-languages class="abs-centered"></app-languages> -->

  <div fxLayout="column" fxLayoutGap="10px" class="form-auth" ngClass.xs="full-w">

    <div class="layout-padd text-center">
      <span class="mat-headline">{{"resetPassComp.newPass" | translate}}</span>
    </div>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'errlink'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>link</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2">{{"resetpass.message.invalidlink" | translate}}</span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="great" *ngIf="error$ === 'success'">

      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>https</mat-icon>
      </div>

      <div fxFlex fxLayoutGap="10px" fxLayoutAlign="space-between" class="layout-padd-2">

        <div fxLayoutAlign="center center" class="text-center">
          <span class="mat-subheading-2">{{"resetPassComp.passModi" | translate}}</span>
        </div>

        <div>
          <button mat-raised-button (click)="goAuth()" angulartics2On="click" angularticsAction="redirectLogin"
            angularticsCategory="resetPassword">{{"resetPassComp.connect" | translate}}</button>
        </div>

      </div>

    </mat-card>

    <form fxLayout="column" fxLayoutGap="10px" ngClass.xs="layout-padd" [formGroup]="newPassForm"
      (ngSubmit)="submitNewPass()">

      <div class="form-field-endorder">

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{"resetpass.word.newpass" | translate}}</mat-label>
          <mat-icon matSuffix color="primary">https</mat-icon>
          <input type="password" matInput formControlName="password" autocomplete="new-password">
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('password')">
            <span class="mat-caption">{{"main.err.reqpass" | translate}}</span>
          </mat-error>
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="newPassForm.controls['password'].errors?.minlength">
            <span class="mat-caption">{{"main.err.passformat" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>


      <div class="form-field-endorder">

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{"resetpass.word.verifnewpass" | translate}}</mat-label>
          <mat-icon matSuffix class="primary-ico">https</mat-icon>
          <input matInput type="password" formControlName="confPassword" autocomplete="new-password">
          <mat-error fxLayoutAlign="start center" *ngIf="isFieldrequired('confPassword')">
            <span class="mat-caption">{{"main.err.verifpassreq" | translate}}</span>
          </mat-error>
          <mat-error fxLayoutAlign="start center" *ngIf="newPassForm.controls['confPassword'].errors?.MatchPassword">
            <span class="mat-caption">{{"main.err.notmatch" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>


      <button mat-raised-button type="submit" color="primary" angulartics2On="click"
        angularticsAction="submitResetPasswordForm" angularticsCategory="resetPassword">{{"resetPassComp.validate" | translate}}</button>

    </form>

  </div>

  <app-popup-loader [flagLoading]="loaderResetPass" [size]="30"></app-popup-loader>

</div>
